import { EYM_TKN, EYM_USR } from "../actions/constants";

let lstg = window.localStorage;
let sstg = window.sessionStorage;
let tken = lstg.getItem(EYM_TKN) || sstg.getItem(EYM_TKN);
let user = lstg.getItem(EYM_USR) || sstg.getItem(EYM_USR);

const initialState = {
	endpoints: [
		{
			id: 1,
			name: "tasks",
			modelName: "task",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				name: "",
				description: "",
				handler: "",
				options: "{}",
				status: "",
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				description: {
					type: "string",
					value1: ".*",
				},
				status: {
					type: "boolean",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 2,
			name: "schedules",
			modelName: "schedule",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				name: "",
				description: "",
				task_id: 0,
				frequency_id: 0,
				status: 0,
				queue_no: 0,
				remarks: "",
				start_date: "",
				end_date: "",
				start_time: "",
				priority: 0,
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				description: {
					type: "string",
					value1: ".*",
				},
				status: {
					type: "boolean",
					value1: "",
				},
				queue_no: {
					type: "queueEnum",
					value1: "",
					label: "queue",
				},
			},
			apiPaged: true,
		},
		{
			id: 3,
			name: "jobqueues",
			modelName: "jobqueue",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: { order: ["id DESC"] },
			listOrder: "ascending",
			form: {
				run_datetime: "",
				ref_id: 0,
				is_processed: "",
				memo: "",
				process_status: 0,
				status: 0,
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				task_id: {
					type: "reference",
					value1: "",
					referenceEndpoint: "tasks",
				},
				// process_status: {
				//     type: 'string',
				//     value1: '.*',
				//     label: 'status'
				// },
				process_status: {
					type: "strEnum",
					value1: ".*",
				},
				queue_no: {
					type: "queueEnum",
					value1: "",
					label: "queue",
				},
			},
			apiPaged: true,
		},
		{
			id: 4,
			name: "providers",
			modelName: "provider",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				name: "",
				description: "",
				status: 1,
				options: "{}",
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				description: {
					type: "string",
					value1: ".*",
				},
				// status: {
				//     type: 'boolean',
				//     value1: ''
				// }
			},
			apiPaged: false,
		},
		{
			id: 5,
			name: "connections",
			modelName: "connection",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				name: "",
				description: "",
				type: "",
				status: 1,
				provider_id: "",
				connection: "{}",
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				description: {
					type: "string",
					value1: ".*",
				},
				status: {
					type: "boolean",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 6,
			name: "datasources",
			modelName: "datasource",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				name: "",
				description: "",
				status: 1,
				connection_id: "",
				datasource: "{}",
				record: "",
				last_modified_field: "",
				last_modified_value: "",
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				description: {
					type: "string",
					value1: ".*",
				},
				status: {
					type: "boolean",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 7,
			name: "users",
			modelName: "User",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				username: "",
				email: "",
				password: "",
			},
			formSchema: {
				password: {
					fieldType: "password",
				},
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				email: {
					type: "string",
					value1: ".*",
				},
			},
			apiPaged: false,
		},
		{
			id: 8,
			name: "roles",
			modelName: "Role",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				name: "",
				description: "",
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				// status: {
				//     type: 'boolean',
				//     value1: ''
				// }
			},
			apiPaged: false,
		},
		{
			id: 9,
			name: "acls",
			modelName: "ACL",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: [],
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {},
			apiPaged: false,
		},
		{
			id: 10,
			name: "frequencies",
			modelName: "frequency",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				code: "",
				name: "",
				description: "",
				status: "",
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				description: {
					type: "string",
					value1: ".*",
				},
				status: {
					type: "boolean",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 11,
			name: "datasourcemappings",
			modelName: "datasourcemapping",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				status: {
					type: "boolean",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 12,
			name: "datasourcemappingfields",
			modelName: "datasourcemappingfield",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				status: {
					type: "boolean",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 13,
			name: "eventlogs",
			modelName: "eventlog",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				name: {
					type: "string",
					value1: ".*",
				},
				status: {
					type: "boolean",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 14,
			name: "messagequeues",
			modelName: "messagequeue",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			// apiFilter: { "order": ["updated_at DESC", "id DESC"] },
			// apiFilter: { "order": [ "id DESC"] },
			apiFilter: { order: ["updated_at DESC"] },
			listOrder: "ascending",
			form: {
				task_id: 0,
				// "name": "",
				// "description": "",
				ref_id: "",
				published_duration: "",
				message: "",
				status: 0,
				remarks: "",
				audit: "",
				message_raw: "",
				id: 0,
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				task_id: {
					type: "reference",
					value1: "",
					referenceEndpoint: "tasks",
				},
				ref_id: {
					type: "string",
					value1: ".*",
					label: "source ID",
				},
				target_id: {
					type: "string",
					value1: ".*",
					label: "target ID",
				},
				status: {
					type: "enum",
					value1: "0",
				},
				updated_at: {
				    type: 'dateTime',
				    value1: '',
				    label: 'Last Modified'
				}
			},
			apiPaged: true,
		},
		{
			id: 15,
			name: "audits",
			modelName: "audits",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: { order: ["id DESC"] },
			listOrder: "ascending",
			form: {
				document_type: "",
				document_id: 0,
				audit: "",
				id: 0,
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				document_type: {
					type: "string",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 16,
			name: "releasenotes",
			modelName: "releasenotes",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: null,
			listOrder: "ascending",
			form: {
				version: "",
				release_date: "",
				notes: "",
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				version: {
					type: "string",
					value1: ".*",
				},
			},
			apiPaged: false,
		},
		{
			id: 17,
			name: "joblogs",
			modelName: "joblogs",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: { order: ["id DESC"] },
			listOrder: "ascending",
			form: {
				task_id: 0,
				process_type: "",
				message_log: 0,
				aumessage_argumentsdit: "",
				id: 0,
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				process_type: {
					type: "string",
					value1: "",
				},
			},
			apiPaged: false,
		},
		{
			id: 18,
			name: "preferences",
			modelName: "preferences",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: { order: ["id DESC"] },
			listOrder: "ascending",
			form: {
				sandbox_type: "",
				export_max_limit: "",
				time_zone: "",
				time_format: "",
				date_format: "",
				id: 0,
				from_email_address: "",
				to_email_address: "",
				cc_email_address: "",
				bcc_email_address: "",
				enable_notification: "",
				notification_start_at: ""
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {},
			apiPaged: false,
		},
		{
			id: 21,
			name: "timezones",
			modelName: "timezones",
			initialized: false,
			isFetching: false,
			didInvalidate: true,
			list: [],
			apiFilter: { order: ["zone_name ASC"] },
			listOrder: "ascending",
			form: {				
				zone_name: "",
				offset: "",
				dst: "",
				id: 0,
			},
			listCount: 0,
			listPages: 0,
			currentListPage: 0,
			itemsPerPage: 25,
			filter: {
				zone_name: {
					type: "string",
					value1: "",
				},
				offset_name: {
					type: "string",
					value1: "",
				}
			},
			apiPaged: false,
		}
	],
	main: {
		endpointId: null,
		endpointListId: null,
		type: null,
		data: null,
		location: null,
	},
	auth: {
		access_token: tken,
		authenticated: tken ? true : false,
		error: null,
		user: user ? JSON.parse(user) : null,
	},
	messageBox: {
		type: null,
		title: "",
		message: "",
		timeout: 5000,
		buttonArray: ["OK"],
		onClick: function (btnIndex) {
			return btnIndex;
		},
		shown: false,
		autoClose: true,
		dateVal: "",
		failedExtract: false,
		failedPublish: false,
	},
	loader: {
		loading: false,
		loadingMessagequeue: false,
		loadingExport: false,
	},
	customModal: {
		type: null,
		title: "",
		message: "",
		timeout: 5000,
		buttonArray: ["OK"],
		onClick: function (btnIndex) {
			return btnIndex;
		},
		shown: false,
		autoClose: true,
		dateVal: "",
		// startDate: "",
		// endDate: "",
		// objectValues:{}
	},
	dateFilter: {
		dateValue: ''
	}
};

export default initialState;



// WEBPACK FOOTER //
// ./src/reducers/store.js